// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"vV-z","inlineTitle":"wV-z","sponsoredAdsWrapper":"xV-z","marketplaceRecosWrapper":"yV-z"};